import { createSlice } from "@reduxjs/toolkit";

const initialUnregisteredStudent = {
  term: 0,
  tcKimlikNo: "",
  name: "",
  surname: "",
  birthDate: "",
  school: "",
  parentName: "",
  parentSurname: "",
  parentPhone: "",
  parentEmail: "",
  address: "",
  explanation: ""
};

const initialUnregisteredStudentState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  unregisteredStudent: initialUnregisteredStudent
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const unregisteredStudentSlice = createSlice({
  name: "unregisteredStudents",
  initialState: initialUnregisteredStudentState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getUnregisteredStudents
    unregisteredStudentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getUnregisteredStudent
    unregisteredStudentFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.unregisteredStudent = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanUnregisteredStudentsState
    unregisteredStudentsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.unregisteredStudent = initialUnregisteredStudent;
    }
  }
});